import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sl-live-stream-request-to-speak',
    standalone: false,
    templateUrl: './live-stream-request-to-speak.dialog.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './live-stream-request-to-speak.dialog.scss'
})
export class LiveStreamRequestToSpeakDialog {}
